// Source: https://www.fmta.org/district--local-officerschairs.html (2026-10-05).
export const FSMTA_DISTRICTS = [
  { id: 1, locals: [['okaloosa','Okaloosa County MTA'], ['pensacola','Pensacola MTA']] },
  { id: 2, locals: [['tallahassee','Tallahassee MTA'], ['northwest-florida','Northwest Florida MTA']] },
  { id: 3, locals: [['gainesville','Gainesville MTA']] },
  { id: 4, locals: [['jacksonville','Jacksonville MTA']] },
  { id: 5, locals: [['brevard','Brevard County MTA'], ['central-florida','Central Florida MTA'], ['volusia','Volusia County MTA']] },
  { id: 6, locals: [['broward','Broward County MTA'], ['miami-dade','Miami-Dade MTA'], ['palm-beach','Palm Beach County MTA'], ['treasure-coast','Treasure Coast MTA']] },
  { id: 7, locals: [['southwest-florida','Southwest FL MTA']] },
  { id: 8, locals: [['sarasota','Sarasota MTA']] },
  { id: 9, locals: [['mid-state','Mid-State MTA'], ['ridge','Ridge MTA'], ['tampa','Tampa MTA'], ['greater-pinellas','Greater Pinellas MTA']] }
];
export function localName(id) {
  return FSMTA_DISTRICTS.flatMap(d => d.locals).find(([key]) => key === id)?.[1] || id;
}
